import type { FC } from 'react'
import styled from 'styled-components'

import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import type { Step } from '@/components/GuideMe'

import StepItem from './StepItem'

interface Props {
  steps: Step[]
  onClose: () => void
}

const Container = styled.div`
  display: grid;
  gap: 20px;
`

const GuideMeSidebar: FC<Props> = ({ steps, onClose }) => {
  return (
    <SlideInSidebar
      onClose={onClose}
      header={
        <>
          <h1>Next steps</h1>
        </>
      }
      content={
        <Container>{steps && steps.map(step => <StepItem step={step} />)}</Container>
      }
    />
  )
}

export default GuideMeSidebar
